export default "__VITE_ASSET__CRm4ves0__"